import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Document\UpdateDocumentController::__invoke
* @see app/Http/Controllers/Document/UpdateDocumentController.php
* @route '/api/document/{document}'
*/
const UpdateDocumentController = (args: { document: string | number } | [document: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateDocumentController.url(args, options),
    method: 'put',
})

UpdateDocumentController.definition = {
    methods: ["put"],
    url: '/api/document/{document}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Document\UpdateDocumentController::__invoke
* @see app/Http/Controllers/Document/UpdateDocumentController.php
* @route '/api/document/{document}'
*/
UpdateDocumentController.url = (args: { document: string | number } | [document: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { document: args }
    }

    if (Array.isArray(args)) {
        args = {
            document: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        document: args.document,
    }

    return UpdateDocumentController.definition.url
            .replace('{document}', parsedArgs.document.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Document\UpdateDocumentController::__invoke
* @see app/Http/Controllers/Document/UpdateDocumentController.php
* @route '/api/document/{document}'
*/
UpdateDocumentController.put = (args: { document: string | number } | [document: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateDocumentController.url(args, options),
    method: 'put',
})

export default UpdateDocumentController